const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.us.forwood.one',
    USER_TOKEN_URL: 'https://i3nmk88ik1.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://qiza44yyd7.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.us.forwood.one',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.us.forwood.one',
    TARGETS_MICROFRONTEND_URL: 'https://targets.us.forwood.one',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.us.forwood.one',
    WEBSOCKET: 'wss://worao5bibi.execute-api.us-west-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
